<span [class]="classes">
    <span class="mvd_photo__bg" [style.background-image]="imageStyle">
        <img [src]="imageUrl" />
    </span>
</span>